<template>
  <div>
    <div>
      <router-link to="/">Home </router-link>
      <label class="labelBar"> / </label>
      <router-link to="/grupoEquipamento"> Cadastro/Equipamento/Grupos </router-link>
      <label class="labelBar"> / </label>
      <label v-if="!readOnly"> Editar</label>
      <label v-else> Ver</label>
    </div>
    <tab-navegacao-equipamento />
    <v-container fluid>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row align="center">
          <v-col>
            <v-text-field
              label="Grupo *"
              v-model="descricao"
              v-uppercase
              :counter="200"
              :readonly="readOnly"
              :rules="[(v) => !!v || 'O nome do grupo é obrigatório']"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row align="center-left">
        <v-col cols="12" sm="6">
          <v-checkbox
            v-model="familia.ativo"
            @click.native.stop.prevent="checkAssociacao()"
            label="Ativo"
            :readonly="readOnly"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6" class="text-right">
          <v-btn to="/grupoEquipamento" color="error" class="mr-4" v-if="!readOnly">
            Voltar
          </v-btn>
          <v-btn to="/grupoEquipamento" color="success" class="mr-4" v-else>
            Voltar
          </v-btn>
          <v-btn @click="enviar" color="success" class="mr-4" v-if="!readOnly">
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-container>
  </div>
</template>

<script>
import TabNavegacaoEquipamento from "../../Tabs/TabCadastroEquipamento";
import { editarFamiliaAsync } from "../../../services/familiaService";
import { mapState, mapActions } from "vuex";
import { getUserPermission } from "@/services/loginService";

export default {
  name: "editarFamilia",
  data: () => ({
    overlay: false,
    valid: true,
    descricao: null,
    readOnly: false,
  }),
  computed: {
    ...mapState("familia", ["familia"]),
    ...mapState("produto", ["produtos"]),
  },
  methods: {
    ...mapActions("produto", ["atualizarProdutos"]),
    async enviar() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        const resposta = await editarFamiliaAsync(
          this.familia.id,
          this.descricao,
          this.familia.ativo
        );
        if (resposta) {
          //this.mensagemErro = resposta;
          //this.mostartMensagemErro = true;
          this.overlay = false;
          this.$alert(resposta.message, "Desculpe, falha na operação!", "error");
        } else {
          this.overlay = false;
          this.$router.push("/grupoEquipamento");
        }
      }
    },
    findProduto(familiaId) {
      return this.produtos.filter((p) => {
        return p.idFamilia == familiaId && p.ativo === true;
      });
    },
    checkAssociacao: async function () {
      if (!this.familia.ativo) {
        if (!this.produtos || this.produtos.length == 0) {
          this.overlay = true;
          await this.atualizarProdutos();
          this.overlay = false;
        }
        var produtos = this.findProduto(this.familia.id);
        if (produtos != null && produtos.length > 0) {
          this.$alert(
            "O(s) produtos(s) '" +
              produtos.map((e) => e.descricao).join("', '") +
              "' estão ativos e associados a essa Família.",
            "Ação não permitida!",
            "error"
          );
          this.familia.ativo = !this.familia.ativo;
        }
      }
    }
  },
  created: function () {
    this.readOnly = !getUserPermission(6);
    this.descricao = this.familia.descricao;
  },
  components: {
    TabNavegacaoEquipamento,
  },
};
</script>